import { mutatorAction } from 'satcheljs';
import { connectedAccountsStore } from '../../store/store';
export var toggleEditAccountWindow = mutatorAction('toggleEditAccountWindow', function (state) {
    var store = connectedAccountsStore();
    store.dialogWindowState.editAccountOpen = state.editAccountOpen;
});
//# sourceMappingURL=toggleEditAccountWindow.js.map